module.exports = __webpack_public_path__ + "img/icon_ai_logo.5777b2d2.png";